import { HTMLTable, Spinner } from '@blueprintjs/core';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import firebase from '../firebase';
import { firestore } from '../firebase';
import { IState } from '../store';


const InventoryContainer = styled('div')`
  overflow: auto;
  flex-direction: row;
  position: fixed;
  /* align-items: center;
  justify-content: center; */
  /* left: 50%; */
  height: 100%;
`;
const TableContainer = styled('div')`
  align-items: center;
  justify-content: center;
  /* left: 25%; */
  flex: 3;
  overflow: auto;
`;

const getCarsForSale= firebase
.functions()
.httpsCallable('getCarsForSale');


class CarsForSaleTable extends React.PureComponent<any, any>{
  public weekAgo = Date.now() - 604800000;
  public dayAgo = Date.now() - 86400000;

  public batchIncrement = 400;
  public batchStart = 0;
  public batchSize = 0;

  constructor(props) {
    super(props);

    this.state = {
      cars: [],
      loading: false,
    };
  }

  public async componentDidMount() {
    const params = this.props.match.params;
    if(params.business){
        const query = await firestore.collection('businesses').where('path', '==', params.business).get();
        const businessDoc = query.docs[0].data();
          if(params.site && params.site !== '-'){
              const siteQuery = await query.docs[0].ref.collection('sites').where('path', '==', params.site).get();
              const siteDoc = siteQuery.docs[0].data();
              this.setState({s3Id: siteDoc.s3Id});
          } else {
              this.setState({s3Id: businessDoc.s3Id});
          }
          this.queryPriceTable();
    }
  }

  public render() {
    const { cars } = this.state;
    if(cars.length === 0){
        return (
            <InventoryContainer>
                <Spinner />
            </InventoryContainer>
        );
    }
    return (
      <InventoryContainer>
          <TableContainer>
          <HTMLTable>
              <thead>
                  <tr>
                      <th>Make</th>
                      <th>Model</th>
                      <th>Year</th>
                      <th>Stock #</th>
                      <th>Sale Price</th>
                      <th>Color</th>
                      <th>VIN</th>
                  </tr>
              </thead>
              <tbody>
                  {cars.map((data , index) => {
                      return this.renderCarRow(data, index);
                  })}
              </tbody>
          </HTMLTable>
          </TableContainer>
      </InventoryContainer>
    );
  }

  private renderCarRow = (car, index) => {
      console.log('rendering');
      console.log(car);
      const price = '$' + car.FORSALEPRICE[0];
      const year = car.iYEAR[0];
      const make = car.MAKE[0];
      const model = car.MODEL[0];
      const stockNumber = car.STOCKNUMBER[0];
      const color = car.COLOR[0];
      const vin = car.VIN[0];

      return (
          <tr key={index}>
            <td>{ make }</td>
            <td>{ model }</td>
            <td>{ year }</td>
            <td>{ stockNumber }</td>
            <td>{ price }</td>
            <td>{ color }</td>
            <td>{ vin }</td>
          </tr>
      )

  }

  private queryPriceTable = async () => {
      console.log("querying price table...");
      const { s3Id } = this.state;
      const carsData = await getCarsForSale({s3Id});
      console.log(carsData);
      this.setState({cars: carsData.data, });
  }
}

const mapStateToProps = ({ inventory: { vehicles } }: IState) => ({ vehicles });

const mapDispatchToProps = {
};

export default connect<any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(CarsForSaleTable);




// WEBPACK FOOTER //
// ./src/views/CarsForSaleTable.tsx